<div class="stepper-body">
    <div class="body-title">
        <span>Hi, {{firstName}}!</span>
    </div>
    <div class="body-description">
        <span>What is your citizenship status?</span>
    </div>
    <div class="body-answers custom-answers">
        <div class="custom-container">
            <button mat-stroked-button class="step-option" [ngClass]="{
                            'selected':isBtnSelected(CitizenshipOptions.US)
                        }" (click)="onAnswerSelected(CitizenshipOptions.US)">
                {{CitizenshipOptions.US}}
            </button>
        </div>
        <div class="custom-container">
            <button mat-stroked-button class="step-option" [ngClass]="{
                            'selected':isBtnSelected(CitizenshipOptions.PermanentResident)
                        }" (click)="onAnswerSelected(CitizenshipOptions.PermanentResident)">
                {{CitizenshipOptions.PermanentResident}}
            </button>
        </div>
        <div class="custom-container">
            <button mat-stroked-button class="step-option" [ngClass]="{
                            'selected':isBtnSelected(CitizenshipOptions.NonPermanentResident)
                        }" (click)="onAnswerSelected(CitizenshipOptions.NonPermanentResident)">
                {{CitizenshipOptions.NonPermanentResident}}
            </button>
        </div>
        <div class="custom-container">
            <button mat-stroked-button class="step-option" [ngClass]="{
                            'selected':isBtnSelected(CitizenshipOptions.NonResidentAlien)
                        }" (click)="onAnswerSelected(CitizenshipOptions.NonResidentAlien)">
                {{CitizenshipOptions.NonResidentAlien}}
            </button>
        </div>
    </div>
</div>
<div class="stepper-footer">
    <mat-divider></mat-divider>
    <div class="step-controls">
        <button mat-stroked-button color="primary"
            (click)="onBack()" class="step-button secondary" [disabled]="false">
            Back
        </button>
        <button mat-flat-button color="primary" (click)="onNext()" class="step-button primary" [disabled]="isNextDisabled()">
            Next
        </button>
    </div>
</div>